import Rules from './modules/rules'
import Formats from './modules/formats'

export default {
  ...Rules,
  ...Formats
}